/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

export const STATE_TYPE = ({
  change: 'CHANGE'
} as const);
export const ALIGN = ({
  vertical: 'vertical',
  horizontal: 'horizontal'
} as const);